import { MainTheme } from '@paretogroup/tess';

export const getIconColor = (isHovered: boolean, isEnabled:boolean): string => {
    if (!isEnabled) {
        return MainTheme.colors['gray-6'];
    }

    return isHovered
        ? MainTheme.colors['fun-lavander-dark']
        : MainTheme.colors['regal-blue-50'];
};
